export const environment = {
    production: true,
    salesForceConfig: {
        domain: 'https://eaton--qa.sandbox.my.salesforce-scrt.com',
        sseUrl: '/eventrouter/v1/sse',
        orgId: '00DO400000LDkP7',
        sourcePortal:'EDA Authenticated'
    },
    apigeeConfig: {
        domain: 'https://api-qa.eaton.com',
        clientId: 'nAAhk5avfEwxdLu5E5MnepGG7yXSv5R4',
        salesForceTokenEndpoint: '/agentforce/enterprise-digital-assistance/v1/server-sent-events',
        messsageEndpoint: '/agentforce/enterprise-digital-assistance/v1/conversation/{convId}/message',
        tokenGenerationEndpoint: '/oauth/accesstoken?grant_type=client_credentials',
        conversationGenerationEndpoint:'/agentforce/enterprise-digital-assistance/v1/conversation',
        typingIndicatorEndpoint:'/agentforce/enterprise-digital-assistance/v1/conversation/{convId}/typing-indicator',
        fileContentEndpoint: '/salesforce/document-content/v1/file-content/{fileId}',
        closeConversationEndpoint: '/agentforce/enterprise-digital-assistance/v1/conversation/{convId}',
        startFeedbackSessionEndpoint: '/agentforce/user-feedback/v1/sessions',
        submitFeedbackEndpoint: '/agentforce/user-feedback/v1/sessions/{sessionId}/feedback',
        endFeedbackSessionEndpoint: '/agentforce/user-feedback/v1/sessions/{sessionId}',
        chatHistoryEndpoint: '/salesforce-data-cloud/v1/query',
        chatHistorySqlQueryPayload: `SELECT con.ssot__CreatedDate__c,con.ssot__ExternalRecordId__c,ce.ssot__PayloadText__c,ecp.ssot__ParticipantDisplayName__c FROM ssot__ConversationEntry__dlm AS ce INNER JOIN ssot__Conversation__dlm AS con ON     ce.ssot__ConversationId__c = con.ssot__ExternalRecordId__c INNER JOIN ssot__MessagingSession__dlm AS ms ON con.ssot__Id__c=ms.ssot__ConversationId__c INNER JOIN ssot__EngagementChannelParticipant__dlm ecp ON ce.ssot__EngagementParticipantId__c = ecp.ssot__ExternalRecordId__c WHERE ce.ssot__ConversationEntryType__c = 'Message' AND ms.Email__c = '{userEmail}' ORDER BY ce.ssot__ClientDateTime__c asc`
    },
    oktaConfig: {
        clientId: '0oa2n69u3oiRrXDkg0h8',
        issuer: 'https://id-qa.eaton.com/oauth2/aus2idkrdxoizIe0k0h8',
        scopes: ['openid', 'profile', 'email'],
    },
}